module.exports = __webpack_public_path__ + "static/media/step3.ae367288.png";